export default "__VITE_ASSET__6f4665ff__"